export interface QueryPayload {
  [field: string]: any;
}

function hasValue(value: any) {
  return value !== undefined && value !== null && String(value).trim() !== "";
}

export function buildModuleQueryFromFilterModel(sdata: any, model: any): QueryPayload {
  const allowedFields = (sdata?.menu?.mnu || []).map((m: any) => m.v);
  const defaultField = model?.defaultField || sdata?.menu?.def || allowedFields[0];
  const payload: QueryPayload = {};

  if (defaultField && allowedFields.includes(defaultField) && hasValue(model?.search)) {
    payload[defaultField] = model.search;
  }

  (model?.conditions || [])
    .filter((c: any) => c && c.field && allowedFields.includes(c.field) && hasValue(c.value))
    .forEach((c: any) => {
      payload[c.field] = c.value;
    });

  return payload;
}
